import type { PlaceResponses, PlaceResult } from '@quromedical/places';
import { trpcClient } from 'trpc';

export class GooglePlaceApi {
  public getAddresses = async (search?: string): Promise<PlaceResponses> => {
    return await trpcClient.place.getAddress.query({
      search,
    });
  };

  public getPlaceDetails = async (placeId: string): Promise<PlaceResult> => {
    return await trpcClient.place.getPlace.query({
      placeId,
    });
  };
}
